import { jsonHeaders } from "@services/api/http";

interface FavoriteResponse {
  success: boolean;
  isFavorited: boolean;
  favoriteCount: number;
}

/**
 * Toggle favorite status for a skin
 * @param skinId The skin ID to toggle favorite for
 * @returns Promise with the new favorite state and count
 */
export async function toggleSkinFavorite(
  skinId: string,
): Promise<FavoriteResponse> {
  const response = await fetch("/skin/favorite", {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify({ skin_id: skinId }),
  });

  if (!response.ok) {
    throw new Error(`Skin favorite toggle failed: ${response.status}`);
  }

  return response.json();
}

/**
 * Increment download count for a skin (fire and forget)
 * @param skinId The skin ID to increment
 */
export async function incrementSkinDownloadCount(skinId: string): Promise<void> {
  if (!skinId) return;

  try {
    await fetch("/skin/download-count", {
      method: "POST",
      headers: jsonHeaders(),
      body: JSON.stringify({ skin_id: skinId }),
    });
  } catch (error) {
    console.error("Skin download count increment failed:", error);
  }
}
